module.exports = __webpack_public_path__ + "static/img/cu.1f0f27b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/cu.png
// module id = s/EG
// module chunks = 18